import React, { createContext, useReducer, useContext } from 'react';
import Member from '../common/model/member';

export const MemberStateContext = createContext(null);
export const MemberDispatchContext = createContext(null);

const reducer = (state, action) => {
  switch (action.type) {
    case 'LOGOUT':
      return null;
    case 'LOGIN':
      return action.payload;
    default:
      throw new Error(`Unknown action: ${action.type}`);
  }
};

export const MemberProvider = ({ children, member }) => {
  const [state, dispatch] = useReducer(reducer, member);

  return (
    <MemberDispatchContext.Provider value={dispatch}>
      <MemberStateContext.Provider value={state}>{children}</MemberStateContext.Provider>
    </MemberDispatchContext.Provider>
  );
};

export const useMember = (): Member => useContext(MemberStateContext);
export const useMemberDispatch = () => useContext(MemberDispatchContext);
